export const getNomeIndicador = indicador =>
  (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
  (indicador === 'artropatia_de_quadril' && 'Quadril') ||
  (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
  (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
  (indicador === 'indicadores_painel_geral' && 'Indicadores do Painel Geral') ||
  (indicador === 'sepse_e_choque_septico' && 'Sepse') ||
  (indicador === 'sindrome_coronariana_aguda' && 'SCA');

export const getIndicadorLC = indicador =>
  (indicador === 'acidente_vascular_cerebral' && 'AVC') ||
  (indicador === 'artropatia_de_quadril' && 'QUA') ||
  (indicador === 'cancer_de_prostata' && 'PRO') ||
  (indicador === 'sepse_e_choque_septico' && 'SEP') ||
  (indicador === 'sindrome_coronariana_aguda' && 'SCA') ||
  (indicador === 'cancer_de_mama' && 'MAM');

export const getTitleIndicador = indicador =>
  (indicador === 'indicadores_painel_geral' && 'Indicadores do Painel Geral') ||
  (indicador === 'acidente_vascular_cerebral' &&
    'Acidente Vascular Cerebral - AVC') ||
  (indicador === 'artropatia_de_quadril' && 'Artropatia de Quadril') ||
  (indicador === 'cancer_de_mama' && 'Câncer de Mama') ||
  (indicador === 'cancer_de_prostata' && 'Câncer de Próstata') ||
  (indicador === 'sepse_e_choque_septico' && 'Sepse e Choque Séptico') ||
  (indicador === 'sindrome_coronariana_aguda' &&
    'Síndrome Coronariana Aguda - SCA');

export const routersLc = {
  MAM: 'cancer_de_mama',
  SCA: 'sindrome_coronariana_aguda',
  AVC: 'acidente_vascular_cerebral',
  SEP: 'sepse_e_choque_septico',
  QUA: 'artropatia_de_quadril',
  PRO: 'cancer_de_prostata',
};
